export function schema_blacklist_whitelist(rules) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column: {
				type: "string",
				title: "Colonne"
			},
			db: {
				title: "Ordonné en fonction de la base de données",
				type: "boolean",
				format: "checkbox",
				default: true
			},
			type: {
				title: "Type",
				type: "string",
				enum: ["image", "video"]
			},
			rules: {
				title: "Ordonné en fonction de règles",
				type: "string",
				enum: rules
			},
			blacklist_weight: {
				type: "number",
				title: "Changement de poids - blacklist",
				default: -50
			},
			whitelist_weight: {
				type: "number",
				title: "Changement de poids - whitelist",
				default: -20
			},
			black_white_lists_edit_prev: {
				type: "boolean",
				default: true,
				options: {
					hidden: true,
				},
			},
		},
	};
}
